// @ts-ignore
import content from './md/crm-pricing-breakdown-comparison.md';

export const meta = {
  slug: 'crm-pricing-breakdown-comparison',
  title: 'CRM Pricing Breakdown: The Defined CRM vs. Jobber vs. Housecall Pro — What You Actually Pay',
  excerpt: 'The sticker price tells one story, but the total cost of ownership tells another. A no-spin comparison of what you actually pay for each CRM.',
  date: 'January 2025',
  readTime: '7 min read',
  image: '/docs/crm-pricing-breakdown-comparison/header.png'
};

export { content };
